import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import "jspdf-autotable";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { toastWarn } from "../../../common/Toast";
import { Box } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const ExpenseReport = (props) => {
  let navigate = useNavigate();
  const locationid = localStorage.getItem("Location");
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );

  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [classicView, setClassicView] = useState(true);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        setLoading(false);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Transcation Date",
      accessorKey: "Transactiondate",
      Cell: ({ row }) =>
        moment(row.original.Transactiondate).format(
          `${dateFormate.toUpperCase()}`
        ), //h:mm A
    },
    {
      header: "Transcation Type",
      accessorKey: "Transactiontype",
      filterFn: "contains",
      size: "150",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            window.open(`/receiving-receipt/${row.original.ID}`, "_blank");
          }}
        >
          {row.original.Transactiontype}
        </Box>
      ),
    },
    {
      header: "Transcation Number",
      accessorKey: "Transactionnumber",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Payee",
      accessorKey: "Vendorname",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.Amount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
  ]);

  const Classiccolumns = [
    {
      title: "Transaction Date",
      field: "Transactiondate",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()}`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    // {
    //   title: "Transaction Type",
    //   field: "TransactionType",
    //   headerFilter: "input",
    //   defaultVisible: true,
    //   formatter: (cell) => {
    //     const data = cell.getRow().getData();
    //     const span = document.createElement("span");

    //     span.textContent = data.TransactionType || "";
    //     span.style.borderRadius = "0.3rem";
    //     span.style.color = "#343f62";
    //     span.style.maxWidth = "18ch";
    //     span.style.textDecoration = "underline";
    //     span.style.textUnderlineOffset = "3px";
    //     span.style.padding = "0.3rem";
    //     span.style.cursor = "pointer";
    //     span.style.display = "flex";
    //     span.style.alignItems = "center";
    //     span.style.overflow = "hidden";
    //     span.style.whiteSpace = "nowrap";
    //     span.style.textOverflow = "ellipsis";

    //     span.addEventListener("click", (e) => {
    //       e.preventDefault();
    //       const saleId = data.ID;
    //       let url = `/receiving-receipt/${saleId}`; // default

    //       url = `/receiving-receipt/${saleId}`;

    //       window.open(url, "_blank");
    //     });

    //     return span;
    //   },
    // },
    {
      title: "Transaction Type",
      field: "TransactionType",
      headerFilter: "input",
      frozen: true,
      defaultVisible: true,
      formatter: function (cell) {
        const rowData = cell.getRow().getData();
        const VendorName = rowData.Transactiontype || ""; // Use correct field name and fallback to empty string
        const VendorId = rowData.ID;
        // Check permission before rendering link

        return `<span style="color:#343f62;font-weight:700;text-decoration:underline;cursor:pointer;" onclick="window.open('/receiving-receipt/${VendorId}', '_blank')">${VendorName}</span>`;
      },
    },
    {
      title: "Transaction Number",
      field: "Transactionnumber",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Vendor Name",
      field: "Vendorname",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    // {
    //   title: "Total Number Of Items",
    //   field: "TotalNumberOfItems",
    //   headerFilter: "input",
    //   defaultVisible: true,
    //   // frozen: true,
    //   formatter: function (cell) {
    //     const value = cell.getValue();
    //     // Format to 2 decimal places, but only if it's a number
    //     return typeof value == "number"
    //       ? value.toFixed(2)
    //       : Number(value).toFixed(2);
    //   },
    // },
    {
      title: "Amount",
      field: "Amount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
  ];

  const apiCall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/expensereport?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&locationid=${selectedlocationid}&currentlocationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            setResponseData(res.data.ResponseData);
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  const muiTableBodyRowProps = ({ row }) => ({
    // console.log(row, "checkthis");
    onClick: () => {
      window.open(`/receiving-receipt/${row.original.ID}`, "_blank");
    },
    sx: { cursor: "pointer" },
  });

  // useEffect(() => {
  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
  //   console.log(
  //     JSON.stringify(columnFilters) + " columnFilters | ",
  //     globalFilter + " globalFilter | ",
  //     pagination.pageIndex + " pagination.pageIndex | ",
  //     pagination.pageSize + " pagination.pageSize | ",
  //     columnIndex,
  //     sorting[0]?.id,
  //     sorting[0]?.desc === undefined
  //       ? "desc"
  //       : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
  //     startdate + " startdate | ",
  //     enddate + " enddate",
  //     "api Call payload"
  //   );

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return { columnname: el.id, value: el.value, id: index + 1 };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/expensereport?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //         sorting[0]?.desc === undefined
  //           ? "desc"
  //           : sorting[0]?.desc === true
  //           ? "desc"
  //           : "asc"
  //       }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
  //         pagination.pageSize
  //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //         globalFilter === undefined ? "" : globalFilter
  //       }&startdate=${startdate}&enddate=${enddate}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData, "res======>");
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //         setRowCount(res.data.ResponseData[0].TotalRecord);
  //         //   barcodeRefs.current = responseData;
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setIsError(true);
  //       console.log(err);
  //       setLoading(false);
  //       return;
  //     });

  //   setIsError(false);
  //   setIsLoading(false);
  //   setIsRefetching(false);
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  // ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Expense Report</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report Period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apiCall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="P">Sonar Pos</h6>
                    <p className="fw-bold p-regular">Expense Report</p>
                    <div className="row mb-2 p-regular">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "Classic View" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}

                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      // Groupvalue={[]}
                      Groupvalue={[]}
                      Reportname={"Expense Report"}
                      frozenRowvalue={0}
                      // layout={"fitDataFill"}
                      Onrefresh={() => apiCall()}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Expense Report"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={[]}
                      columnsVisibility={{}}
                      enableRowSelection={false}
                      // muiTableBodyRowProps={muiTableBodyRowProps}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ExpenseReport;
